export const CONST = {

    dynamicHeader: {
        servletUrl: "https://www.fundstore.it/fs/displaymenu",
        // servletUrl: "http://88.35.148.186/fs/displaymenu",
        mainSiteBaseUrl: "https://www.fundstore.it/fs",
        // mainSiteBaseUrl: "http://88.35.148.186/fs",

        mainSiteBlogPageCode: "BLOG",

        wordpressMenuEndpointUrl: "/wp-json/navigation/wp-menu"
    }

}